import React, { useEffect, useContext, useState } from 'react';
import {
  Grid,
  Checkbox,
  Button,
} from "@material-ui/core/";

import SearchField from '../../../../../../../../../util/searchPedido/.mixins';
import OpcoesBuscaPopoverAllFilter from '../../../../../../../../../util/opcoesBuscaPopoverAllFilters/.mixins';
import CardPedido from '../../../../../../../../../util/cardPedido/.mixins';
import ModalTableV2 from '../../../../../../../../../util/modalDinamica/childrens/modalTableV2/.mixins';
import Paginacao from '../../../../../../../../../util/paginacao/.mixins/paginacao';
import MultiSelectModal from '../../../../../../../../../util/modalDinamica/childrens/modalRadioButton/.mixins/multiSelectModal';
import DialogCalendar from '../../../../../../../../../util/calendar/.mixins';
import { AuthContext } from '../../../../../../../../../../contexts/AuthContext';

import ModalAgendPenAvisoRecusa from '../childrens/modalAgendPenAvisoRecusa/.mixins';
import ModalAgendPenAvisoConfirmar from '../childrens/modalAgendPenAvisoConfirmar/.mixins';

//css
import StylesCss from './styles';
import { Can } from '../../../../../../../../../util/Can';
const useStyles = StylesCss();

export default (props) => {
  const {
    state: {
      searchFieldAgendamentoPendentes,
      colunasAgendamentoPendentes,
      colunasFilterTagsAgendamentoPendentes,
      opcoesFilial,
      escolhaFilialAgendamentoPendentes,
      opcoesFiltroPedidos,
      dataAgendamentoPendentes,
      dataAgendamentoPendentesSelected,
      qtdAgendamentoPendentes,
      pageRowsAgendamentoPendentes,
      isOpenModalTableAgendamentoPendentes,
      isLoading,
      descriptionsModalTableAgendamentoPendentes,
      columnsAgendamentoPendentes,
      itensTableAgendamentoPendentes,
      openModalRecusaAgendamentoPendentes,
      openModalMotivoRecusaAgendamentoPendentes,
      opcoesMotivosRecusa,
      escolhaMotivoRecusaAgendamentoPendentes,
      dataSugestaoEntrega,
      openDialogCalendarAgendamentoPendentes,
      openModalConfirmarAgendamentoPendentes,
      itensTableSelectedAgendamentoPendentes,
      rowsPerPageModalAgendamentoPendentes,
      rowsPerPageOptionsAgendamentoPendentes,
      pageModalAgendamentoPendentes,
      countModalAgendamentoPendentes,
      firstLoad,
      dtInitialAgendamentoPendentes,
      dtEndAgendamentoPendentes,
      fornecedor
    },
    loadDataModalAgendamentoPendentes,
    changePageModalAgendamentoPendentes,
    handlerChangeRowsPerPageAgendamentoPendentes,
    handleChangeSearchFieldPedidoAgendamentoPendentes,
    handleClickSearchFieldAgendamentoPendentes,
    handlerCleanFiltersAgendamentoPendentes,
    handlerAplicarFiltersAgendamentoPendentes,
    handlerClearFilterTagAgendamentoPendentes,
    handlerClickCheckboxAgendamentoPendentes,
    handlerCheckboxAllAgendamentoPendentes,
    handlerSelectCheckboxAgendamentoPendentes,
    handlerOnChangeAgendamentoPendentes,
    handleDialogModalTableAgendamentoPendentes,
    handleModalRecusaCloseAgendamentoPendentes,
    handleModalMotivoRecusaCloseAgendamentoPendentes,
    handleModalMotivoRecusaChangeAgendamentoPendentes,
    handleModalMotivoRecusaConfirmAgendamentoPendentes,
    handlerOnChangeDataSugestaoEntregaAgendamentoPendetes,
    handlerOpenDataSugestaoAgendamentoPendetes,
    handleModalConfirmarCloseAgendamentoPendentes,
    handleModalConfirmarSelecionadosAgendamentoPendentes,
    handleImprimirAgendamentoPendentes,
    handlerConfirmarDataSugestaoAgendamentoPendetes,
    handlerConfirmarTodosSelecionadosAgendamentoPendentes,
    handlerRecusarTodosSelecionadosAgendamentoPendentes,
    handlerChangeDateInitialAgendamentoPendentes,
    handlerChangeDateEndAgendamentoPendentes,
    handlerChangeEscolhaFilialAgendamentoPendentes,
    getFilters
  } = props;
  const classes = useStyles();

  const { user: { isVisaoTok } } = useContext(AuthContext);
  const { user } = useContext(AuthContext);
  const [controlUpdate, setControlUpdate] = useState(false);

  const loadData = async () => {
    // Retira histórico rowsperpage
    await props.setState({ pageRowsAgendamentoPendentes: 5 });
    await props.setState({ isLoading: true });
    setControlUpdate(true);

    if (user.permissions["gerenciar-pedidos.recusa-confirmacao"]) {
      await props.loadMotivos();
    }

    await props.loadAgendamentoPendentes({
      linhaInicial: 0,
      qtdRegistro: 5,
      nrPc: ''
    });
    await props.setState({ isLoading: false });
  };

  const loadInit = async () => {
    if (isVisaoTok) {
      const position = getFilters().colunasFilterTagsAgendamentoPendentes.findIndex(x => x.key === "Fornecedor")
      if (position !== -1) {
        handlerClearFilterTagAgendamentoPendentes(position)
      }
    }
    await props.handlerJustCleanFiltersAgendamentosPendentes();
    await loadData();
  };

  useEffect(() => {
    loadInit();
  }, [props.state.fornecedor]);

  const listaCardPedido = dataAgendamentoPendentes.map((params, i) =>
    <div key={i}>
      <Grid container spacing={2}>
        {!user.permissions["gerenciar-pedidos.recusa-confirmacao"] &&
          <Grid item xs={12}>
            <CardPedido {...params} />
          </Grid>
        }

        {user.permissions["gerenciar-pedidos.recusa-confirmacao"] &&
          <>
            <Grid item xs={1} className={classes.checkboxCenter}>
              <Checkbox
                checked={
                  (dataAgendamentoPendentesSelected.filter(e => (JSON.stringify(e)) == (JSON.stringify(params)))).length > 0
                }
                onChange={() => { handlerSelectCheckboxAgendamentoPendentes(params) }}
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            </Grid>
            <Grid item xs={11}>
              <CardPedido {...params} />
            </Grid>
          </>
        }
      </Grid>
    </div>
  );

  const NotListaCardPedido = () => {
    return (
      <div align={"center"}>
        {"Nenhum registro encontrado!"}
      </div>
    );
  };

  const FooterComponente = () => {
    let totalSelected = itensTableSelectedAgendamentoPendentes.length || 0;
    return (
      <div align={"center"} style={{ padding: 20 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              variant="outlined"
              color="primary"
              disabled={totalSelected === 0}
              onClick={() => { handlerOpenDataSugestaoAgendamentoPendetes(true) }}
            >

              {`Recusar ( ${totalSelected} ) todos itens pedido`}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              color="primary"
              disabled={totalSelected === 0}
              onClick={handleModalConfirmarSelecionadosAgendamentoPendentes}
            >
              {`Confirmar ( ${totalSelected} ) todos itens pedido`}
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <>
      <SearchField
        searchField={searchFieldAgendamentoPendentes}
        searchStatus={colunasAgendamentoPendentes[0].value}
        handleChangeSearchFieldPedido={handleChangeSearchFieldPedidoAgendamentoPendentes}
        handleClickSearchField={handleClickSearchFieldAgendamentoPendentes}
      />
      <br /><br />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <OpcoesBuscaPopoverAllFilter
            searchField={searchFieldAgendamentoPendentes}
            dtInitial={dtInitialAgendamentoPendentes}
            dtEnd={dtEndAgendamentoPendentes}
            escolhaData={"Data agendamento"}
            escolhaFilial={escolhaFilialAgendamentoPendentes}
            isColunasMultiple={true}
            isFixed={true}

            colunas={colunasAgendamentoPendentes}
            colunasFilterTags={colunasFilterTagsAgendamentoPendentes}
            opcoesFilial={opcoesFilial}
            opcoesFiltroPedidos={opcoesFiltroPedidos}

            handlerCleanFilters={handlerCleanFiltersAgendamentoPendentes}
            handlerAplicarFilters={handlerAplicarFiltersAgendamentoPendentes}
            handlerClearFilterTag={handlerClearFilterTagAgendamentoPendentes}
            handleChangeSearchFieldPedido={handleChangeSearchFieldPedidoAgendamentoPendentes}
            handlerClickCheckbox={handlerClickCheckboxAgendamentoPendentes}
            handlerChangeEscolhaFilial={handlerChangeEscolhaFilialAgendamentoPendentes}

            handlerChangeDateInitial={handlerChangeDateInitialAgendamentoPendentes}
            handlerChangeDateEnd={handlerChangeDateEndAgendamentoPendentes}
          />
        </Grid>
        {qtdAgendamentoPendentes > 0 &&
          <Grid item xs={6} align={"right"}>
            Total de {qtdAgendamentoPendentes}
            {qtdAgendamentoPendentes === 1 ? ' agendamento pendente' : ' agendamentos pendentes'}
          </Grid>
        }
      </Grid>
      <br />
      {dataAgendamentoPendentes.length > 0 &&
        <>
          <>
            <Can permissions={['gerenciar-pedidos.recusa-confirmacao']}>
              <Grid container spacing={2}>
                <Grid item xs={1}>
                  <Checkbox
                    className={classes.checkboxCenter}
                    checked={dataAgendamentoPendentesSelected.length == qtdAgendamentoPendentes}
                    onChange={handlerCheckboxAllAgendamentoPendentes}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                </Grid>
                <Grid item xs={11}></Grid>
              </Grid>
            </Can>
            {listaCardPedido}
          </>
          <br />
          <Paginacao
            rowsPerPage={pageRowsAgendamentoPendentes}
            setRowsPerPage={handlerChangeRowsPerPageAgendamentoPendentes}
            totalRows={qtdAgendamentoPendentes}
            rowsPerPageOptions={rowsPerPageOptionsAgendamentoPendentes}
            onChangePage={handlerOnChangeAgendamentoPendentes}
            firstLoad={firstLoad}
          />
          <br />
          {(
            user.permissions["gerenciar-pedidos.recusa-confirmacao"] &&
            dataAgendamentoPendentesSelected.length > 0
          ) &&
            <Grid container spacing={2} align={"center"}>
              <Grid item xs={6}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handlerRecusarTodosSelecionadosAgendamentoPendentes}
                >
                  {`RECUSAR (${dataAgendamentoPendentesSelected.length}) AGENDAMENTOS`}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlerConfirmarTodosSelecionadosAgendamentoPendentes}
                >
                  {`CONFIRMAR (${dataAgendamentoPendentesSelected.length}) AGENDAMENTOS`}
                </Button>
              </Grid>
            </Grid>
          }
        </>
      }
      {dataAgendamentoPendentes.length == 0 &&
        <NotListaCardPedido />
      }
      <ModalTableV2
        descriptionsModalTable={descriptionsModalTableAgendamentoPendentes}
        itensTable={itensTableAgendamentoPendentes}
        columns={columnsAgendamentoPendentes}
        isOpenModalTable={isOpenModalTableAgendamentoPendentes}
        isLoading={isLoading}
        handleDialogModalTable={handleDialogModalTableAgendamentoPendentes}
        FooterComponente={user.permissions["gerenciar-pedidos.recusa-confirmacao"] && FooterComponente}
        loadDataModal={loadDataModalAgendamentoPendentes}
        changePage={changePageModalAgendamentoPendentes}
        rowsPerPage={rowsPerPageModalAgendamentoPendentes}
        page={pageModalAgendamentoPendentes}
        count={countModalAgendamentoPendentes}
      />
      <ModalAgendPenAvisoRecusa
        open={openModalRecusaAgendamentoPendentes}
        handleClose={handleModalRecusaCloseAgendamentoPendentes}
      />
      <ModalAgendPenAvisoConfirmar
        open={openModalConfirmarAgendamentoPendentes}
        handleClose={handleModalConfirmarCloseAgendamentoPendentes}
        handleImprimir={handleImprimirAgendamentoPendentes}
      />
      <MultiSelectModal
        checkedId={escolhaMotivoRecusaAgendamentoPendentes}
        isModalOpen={openModalMotivoRecusaAgendamentoPendentes}
        headerModal={{
          title: "POR QUAL RAZÃO VOCÊ NÃO CONSEGUIRÁ REALIZAR A ENTREGA DO PRODUTO NA DATA PROPOSTA?",
          subtitle: "Lembre-se que você deverá, posteriormente, confirmar o agendamento desses pedidos."
        }}
        btComponent={{ label: "SELECIONAR" }}
        buttonType={'radio'}
        itensModal={opcoesMotivosRecusa}
        setIdOnChange={handleModalMotivoRecusaChangeAgendamentoPendentes}
        getIdOnClick={handleModalMotivoRecusaConfirmAgendamentoPendentes}
        handleDialogModal={handleModalMotivoRecusaCloseAgendamentoPendentes}
      />
      <DialogCalendar
        popupLabel={"SUGESTÃO DE NOVA DATA DE ENTREGA"}
        value={dataSugestaoEntrega}
        openDialogCalendar={openDialogCalendarAgendamentoPendentes}
        handlerChangeDate={handlerOnChangeDataSugestaoEntregaAgendamentoPendetes}
        handlerOpenDataSugestao={handlerOpenDataSugestaoAgendamentoPendetes}
        handlerConfirmarDataSugestao={handlerConfirmarDataSugestaoAgendamentoPendetes}
      />
    </>
  );
};
